/*
 * Copyright (C) 2025 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { cva, VariantProps } from 'class-variance-authority';
import { IconComponent } from '../icon/icon.component';

export const badgeVariants = cva('flex gap-1 items-center rounded-full text-sm', {
  variants: {
    variant: {
      default: 'text-whitetext bg-primary',
      outline: 'border bg-whitetext border-primary text-primary',
      success: 'text-whitetext bg-success',
    },
    size: {
      small: 'px-2 py-0.5',
      medium: 'px-5 py-1',
    },
  },
  defaultVariants: {
    variant: 'default',
    size: 'small',
  },
});

export type BadgeVariants = VariantProps<typeof badgeVariants>;

@Component({
  selector: 'ods-badge',
  imports: [CommonModule, IconComponent],
  template: `<p [ngClass]="badgeVariants({ variant, size })">
    @if (icon) {
      <ods-icon [name]="icon" size="small" [fill]="iconFill" />
    }
    {{ name }}
  </p>`,
  host: { class: 'block w-fit' },
})
export class BadgeComponent {
  @Input() name: string;
  @Input() icon: string;
  @Input() variant: BadgeVariants['variant'];
  @Input() size: BadgeVariants['size'];

  public readonly badgeVariants = badgeVariants;

  get iconFill(): string {
    return this.variant === 'outline' ? 'primary' : 'whitetext';
  }
}
